import { Routes } from '@angular/router';
import { NotAuthorizedComponent } from './views/core/not-authorized/not-authorized.component';

export const routes: Routes = [
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent
  },
  {
    path: 'appointment',
    loadChildren: () => import('./views/appointment/appointment.module').then(m => m.AppointmentModule)
  },

  {
    path: ':id',
    loadChildren: () => import('./views/video-chat/patient/video-chat-patient.module').then(m => m.VideoChatPatientModule),
    pathMatch: 'full'
  },

  { path: '**', component: NotAuthorizedComponent, pathMatch: 'full' }
];
